import { render, staticRenderFns } from "./TabFooter.vue?vue&type=template&id=51607024&"
import script from "./TabFooter.vue?vue&type=script&lang=js&"
export * from "./TabFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports